
export var React = window.React || function() {console.error('no reactjs found'); return false}




/** WEBPACK FOOTER **
 ** ../../libs/reactjs/index.js
 **/